
<template>
  <tbody style="cursor: pointer">
    <v-menu
      offset-y
      max-width="200"
      nudge-right="100"
      :close-on-content-click="false"
      v-model="menu[booking.id.toString()]"
      v-if="booking != null"
    >
      <template v-slot:activator="{ on }">
        <tr
          v-on="on"
          v-if="booking != null"
          valign="top"
          @click="setSelectedBooking(booking.id, -1)"
          v-bind:style="colorForBooking(booking)"
        >
          <td>
            <div
              class="fixed-table-row-2"
              v-if="
                booking.taxi_id != null &&
                booking.taxi_id != 0 &&
                booking.driver_id != null &&
                booking.driver_id != 0
              "
            >
              <span v-on="on">
                <b>{{ booking.driver_callsign }}</b
                >&nbsp;
                {{ shortName(booking.driver_name) }}
              </span>
            </div>
          </td>
          <td>{{ timeForBooking(booking.pickup_time, booking.asap) }}</td>
          <td>{{ booking.pickup_time.substring(0, 10) }}</td>
          <td>
            <div class="fixed-table-row">
              {{ prettify(booking.pickup_location) }}
            </div>
          </td>
          <td>
            <ViasForBooking :booking="booking" />
          </td>
          <td>
            <div class="fixed-table-row">
              {{ destinationForBooking(booking) }}
            </div>
          </td>
          <td v-if="!expanded">
              <span style="display: none" data-type="metadata">{{ getViaInfoStringForBooking(booking) }}</span>
              <div class="fixed-table-row">
              {{ nameOrRoomForCustomerForBooking(booking) }}
            </div>
          </td>
          <td v-if="!expanded">
            <AttributesForBookingCell :booking="booking" />
          </td>
           <td style="display:none;">
              {{ JSON.stringify(booking) }}
            </td>
        </tr>
      </template>
      <BookingMenu
        @copy="copy(booking)"
        @edit="edit(booking.id)"
        @close="menu[booking.id.toString()] = false"
        :booking="booking"
      />
    </v-menu>
  </tbody>
</template>

<script>
import BookingMenu from "@/components/widget/menu/BookingMenu.vue";

import AttributesForBookingCell from "@/components/widget/AttributesForBookingCell.vue";
import moment from "moment";

import { Overwatch } from "@/components/util/Overwatch.js";

import ViasForBooking from "@/components/overwatch/ViasForHistoryBooking.vue";

import qs from "qs";
import axios from "axios";
import { setTimeout } from "timers";
axios.defaults.withCredentials = true;

export default {
  name: "HistoryTableRows",
  components: {
    AttributesForBookingCell,
    BookingMenu,
    ViasForBooking,
  },
  props: {
    booking: Object,
    selectedTaxi: Number,
    selectedBooking: Number,
    setSelectedTaxi: Function,
    setSelectedBooking: Function,
    expanded: {
      default: false,
      type: Boolean
    },
  },
  computed: {},
  data() {
    return {
      ABOUT_TO_CLEAR_TIME: 1,
      menu: {},
    };
  },
  methods: {
   getViaInfoStringForBooking: function (b) {
          if (b.via_info && b.via_info.length) {
              return JSON.stringify(b.via_info).toUpperCase()
          }
          return ''
   },
   copy: function (booking) {
   this.getBookingForEdit(booking.id);
    },
    async getBookingForEdit(bookingID) {
      try {
        var url = `${this.$store.state.apiUrl}/booking/${bookingID}/get`;

        let response = await axios.get(url, {
          params: {},
        });

        if (response.error == null || response.error == "no_error") {
          console.log("Emitting booking for copy");
          console.log(response.data.booking);

          response.data.booking.customer_number =
            response.data.booking.user.contact_number;

          this.$emit("copy", response.data.booking);
        } else {
          return response.data.error;
        }
      } catch (error) {
        console.log("Failed to get booking " + error);
        return "Unknown Error";
      }
    },
    edit: function (bookingID) {
      this.$emit("edit", bookingID);
    },
    reassign: function (b) {
      this.$emit("reassign", b);
    },
    colorForBooking: function (booking) {
      var style = {};

      if (booking.state == "cancelled") {
        style.backgroundColor = "#a1a1a1";
      }

      if (this.selectedBooking == booking.id) {
        // style.backgroundColor = "red";
        style.boxShadow = "inset 0 0 0 99999px rgba(0,0,0,0.15)";
      }

      return style;
    },
    timeForBooking: function (timeString, asap) {
      var time = moment(timeString, "DD/MM/YYYY HH:mm");

      var timeFormatted = `${time.format("HH:mm")}`;

      if (asap == true) {
        timeFormatted = timeFormatted;
      }

      return timeFormatted;
    },
    minutesToHoursMinutesString: function (minutes) {
      var duration = moment.duration(minutes, "minutes");

      if (minutes == 0) {
        return 0;
      }

      var hoursMinutesString = Overwatch.durationToHoursMinutesString(
        duration,
        ""
      );

      return hoursMinutesString;
    },
    colorForFollowOn: function (booking) {
      var style = {};

      if (this.selectedBooking == booking.id) {
        // style.backgroundColor = "red";
        style.boxShadow = "inset 0 0 0 99999px rgba(0,0,0,0.1)";
      }

      return style;
    },
    prettify: function (d) {
      return Overwatch.prettifyAddress(d);
    },
    destinationForBooking: function (b) {
      if (b.destinations != null && b.destinations.length > 0) {
        return Overwatch.prettifyAddress(b.destinations[0]);
      }
    },
    shortName: function (d) {
      return d.substring(0, 10);
    },
    nameOrRoomForCustomerForBooking: function (b) {
      
      if (b.room_number != null && b.room_number != "" && b.business_customer_name != null && b.business_customer_name != "") {
        return b.room_number + " - " + b.business_customer_name.substring(0, Math.min(5, b.business_customer_name.length)); ; 
      } else if (b.business_customer_name != null && b.business_customer_name != "") {
        return b.business_customer_name;
      } else if (b.room_number != null && b.room_number != "") {
        return b.room_number + " - " + b.customer_name.substring(0, Math.min(5, b.customer_name.length));
      } else {
        return b.customer_name;
      }
    },
    tooltipForTaxi: function (taxi, driver) {
      taxi.driver = driver;
      var ow = new Overwatch([], []);

      return ow.tooltipForTaxi(taxi);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.fixed-table-row {
  overflow: hidden;
  height: 16px;
  text-overflow: clip;
}

.fixed-table-row-2 {
  height: 16px;
  overflow: hidden;
  text-overflow: clip;
  max-lines: 1;
  white-space: nowrap;
  word-wrap: break-word;
  word-break: break-all;
}
</style>
